import { type QueueState } from "./state";

export const initialState: QueueState = {
  queue: [],
  page: 1,
  pageSize: 10,
  totalItems: 0,
  totalPages: 0,
  statusCounts: { pending: 0, retry: 0, process: 0 },
  listRequestId: null,
  zones: [],
  geoCatalog: [],
  isSavingAddress: false,
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isActing: false,
  actionError: "",
  logs: [],
  isLoadingLogs: false,
  isLogging: false,
};
